import * as React from 'react';

import ReactDOMServer from 'react-dom/server';

import {CustomAddOnEmptyState} from './custom-add-on-empty-state';
import {CustomAddOnPlaceholder} from './custom-add-on-placeholder';
import type {CustomAddOn, SpecialState} from './custom-add-on-select-modal';

// Matches unique handle value in BEE SDK
export const FORM_ADD_ON_ID: CustomAddOn = 'nutshell-form';
export const SCHEDULER_ADD_ON_ID: CustomAddOn = 'nutshell-scheduler';

export const getHtmlCustomAddOnPlaceholder = (
    addOnType: CustomAddOn,
    name: string,
    value: string
): string => {
    return ReactDOMServer.renderToString(
        <CustomAddOnPlaceholder addOnType={addOnType} name={name} value={value} />
    );
};

export const getHtmlCustomAddOnAddBlockContent = (addOnType: CustomAddOn): string => {
    return ReactDOMServer.renderToString(<CustomAddOnEmptyState addOnType={addOnType} />);
};

export const useManageSpecialState = (
    isLoading: boolean,
    isFirstLoad: boolean,
    isEmptyState: boolean,
    setSpecialState: (specialState?: SpecialState | null | undefined) => void
) => {
    React.useEffect(() => {
        if (isFirstLoad) {
            setSpecialState('loading');
        } else {
            setSpecialState(null);
        }
    }, [setSpecialState, isFirstLoad]);

    React.useEffect(() => {
        if (isEmptyState) {
            setSpecialState('empty');
        }
    }, [isEmptyState, setSpecialState]);
};
